import ShadeGenerator from "shade-generator";
import { type Shade } from "shade-generator/dist/models";
export type ColorPalette = {
  colorPrimary: string;

  colorLighter?: string;
  colorLight?: string;
  colorDark?: string;
  colorDarker?: string;

  colorSecondary: string;

  colorSecondaryLighter?: string;
  colorSecondaryLight?: string;
  colorSecondaryDark?: string;
  colorSecondaryDarker?: string;

  colorInfo?: string;
  colorSuccess?: string;
  colorWarning?: string;
  colorError?: string;

  colorAccentDark?: string;
  colorAccentLight?: string;
  colorAccentSemiLight?: string;
  colorAccentExtraLight?: string;

  colorCustomBorder?: string;

  colorCustomHighlight?: string;
};
export type SkinConfig = {
  colorPalette: ColorPalette;
  sizeConfig: {
    fontSize: number;
    borderRadius: number;
    fontFamily: string;
    rootVariables?: string;
  };
};

export const getCSSByPalette = (
  {
    colorLighter,
    colorPrimary,
    colorLight,
    colorDark,
    colorDarker,
    colorSecondary,
    //colorSecondaryLighter,
    //colorSecondaryLight,
    colorSecondaryDark,
    colorSecondaryDarker,

    colorAccentDark,
    colorAccentLight,
    colorAccentSemiLight,
    colorAccentExtraLight,

    colorCustomBorder,

    colorCustomHighlight
  }: ColorPalette,
  fontFamily: string,
  fontSize: string,
  rootVariables?: string
) => {
  return `
            :root {
            --main-color-lighter: ${colorPrimary}2b;
            --main-color-light: ${colorPrimary}a3;
            --main-color: ${colorPrimary};
            --main-color-dark:  ${colorDark};
            --main-color-darker:  ${colorDarker};

            --secondary-color-lighter: ${colorSecondary}2b;
            --secondary-color-light: ${colorSecondary}75;
            --secondary-color: ${colorSecondary};
            --secondary-color-dark:  ${colorSecondaryDark};
            --secondary-color-darker:  ${colorSecondaryDarker};

            --main-font: ${fontFamily};
            --text: ${fontSize}px;

            --accent-xtralight: ${colorAccentExtraLight ?? "#EFF6FF"};
            --accent-semilight: ${colorAccentSemiLight ?? "#DDEAFB"};
            --accent-light: ${colorAccentLight ?? "#89ABDB"};
            --accent-dark: ${colorAccentDark ?? "#3B76BA"};

            --main-color-custom-light: ${colorLight};
            --main-color-custom-lighter: ${colorLighter};
            --main-color-custom-border: ${colorCustomBorder};

            --custom-highlight: ${colorCustomHighlight || colorLight};
            ${rootVariables ?? ''}
        }`;
};

export const getPalette = (
  colorPrimary: string,
  colorSecondary: string,
  colorAccentDark?: string,
  colorAccentLight?: string,
  colorAccentSemiLight?: string,
  colorAccentExtraLight?: string,
  colorCustomLight?: string,
  colorCustomLighter?: string,
  colorCustomBorder?: string,
  colorCustomHighlight?: string,
) => {
  const palette: ColorPalette = {
    colorPrimary,
    colorLighter: colorCustomLighter ?? (getColorShade(colorPrimary, "40") + "2b"),
    colorLight: colorCustomLight ?? (getColorShade(colorPrimary, "70") + "a3"),
    colorDark: getColorShade(colorPrimary, "500"),
    colorDarker: getColorShade(colorPrimary, "700"),
    colorSecondary,
    colorSecondaryLighter: getColorShade(colorSecondary, "40"),
    colorSecondaryLight: getColorShade(colorSecondary, "70"),
    colorSecondaryDark: getColorShade(colorSecondary, "500"),
    colorSecondaryDarker: getColorShade(colorSecondary, "700"),

    colorAccentDark,
    colorAccentLight,
    colorAccentSemiLight,
    colorAccentExtraLight,

    colorCustomBorder: colorCustomBorder ?? colorCustomLighter,

    colorCustomHighlight
  };
  return palette;
};

const getColorShade = (color: string, shade: Shade) => {
  return ShadeGenerator.hue(color).shade(shade).hex();
};

export const getSkinConfigByUnivers: (brand: string) => SkinConfig = (
  brand: string
) => {
  switch (brand.toLowerCase()) {
    case "atlantic":
      return {
        colorPalette: getPalette(
          "#F26F5F",
          "#4f8bd1", //"#2c2e34",
          "#AD0600",
          "#000000",
          "#F3F3F3",
          "#F3F3F3",

          "#FDF2E6",
          "#FFF2E6",
          "#F2C8C1", //
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Poppins",
        },
      };

    case "thermorfr1":
      return {
        colorPalette: getPalette(
          "#E62814",
          "#2c2e34",
          "#000000",//"#FFB000",
          "#00B8A8",
          "#F1F1F1",
          "#F1F1F1",

          "#FFFFFF", //"#FFF2E6",
          "#FFFFFF", //"#FFF2E6"
          "#DADBDC", //
          "#E9EBF0"
        ),
        sizeConfig: {
          fontSize: 14,
          borderRadius: 2,
          fontFamily: "Figtree",
          rootVariables: "--input-radius:2px;  --button-radius:2px;  --app-width:1400px;  --text:13px"
        },
      };

    default:
      return {
        colorPalette: getPalette(
          "#F26F5F",
          "#4f8bd1", //"#2c2e34",
          "#AD0600",
          "#000000",
          "#F3F3F3",
          "#F3F3F3",

          "#FDF2E6",
          "#FFF2E6"
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Poppins",
        },
      };
  }
};

//export const getMainColorsByUnivers = (brand: string) => {
//    switch (brand.toLowerCase()) {
//        case 'atlantic':
//            return ['#934f9a', '#679480'];
//        case 'thermor':
//            return ['#e62814', '#2c2e34'];

//        default:
//            return ['#2c2e34', '#e62814'];
//    }

//};
